import type {getContentSearchResults_searchPage_results_learnableContent_mappedStandards as MappedStandard} from "./hooks/__graphql-types__/getContentSearchResults.ts";

export function formatStandards(standards: MappedStandard[]): string[] {
    const standardsBySet = new Map<string, string[]>();

    for (const entry of standards) {
        if (entry.setId && entry.standardId) {
            const previousEntries = standardsBySet.get(entry.setId) || [];

            standardsBySet.set(entry.setId, [
                ...previousEntries,
                entry.standardId,
            ]);
        }
    }

    const results: string[] = [];

    for (const [setId, standardIds] of standardsBySet.entries()) {
        results.push(`${setId}: ${standardIds.join(", ")}`);
    }

    return results;
}
